import { motion } from "framer-motion";
import { SidebarActions } from "@rapid/components/layout/SidebarActions";
import Button from "@scripts/react/components/Button";
import { BuildStep, Flow, DeployStep } from "@rapid/types/flows";
import { useAnalytics } from "@rapid/contexts/AnalyticsContext";
import { useAuth } from "@rapid/contexts/AuthContext";
import { useFlow } from "@rapid/contexts/FlowContext";
import { useFlowState } from "@rapid/hooks/useFlowState";
import { AnalyticsFlowEvent } from "@rapid/analytics/types";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useCurrentMedia } from "@rapid/store";
import { usePageNavigationShortcut } from "@rapid/hooks/usePageNavigationShortcut";
import { MetricsSnippet } from "@rapid/components/flow/deploy/MetricsSnippet";
import { DEFAULT_DURATION } from "@rapid/constants/motion";

export const IntegrateSidebarActions = ({
    previousFlow,
    previousStep
}: {
    previousFlow: Flow;
    previousStep: BuildStep | DeployStep;
}) => {
    const { task, reset } = useFlow();
    const { flow, step } = useFlowState();
    const { track } = useAnalytics();
    const { user } = useAuth();
    const navigate = useNavigate();
    const currentMedia = useCurrentMedia();

    const handleBackClick = useCallback(() => {
        track({
            event: AnalyticsFlowEvent.BACK,
            data: { task, from: { flow, step }, to: { flow: null, step: null } }
        });

        navigate("/");
        reset();
    }, [track, task, flow, step, navigate, reset]);

    // Keyboard shortcut: Command + Left Arrow

    return (
        <>
            {/* Removing for now until we have a better Rapid <-> sales pipeline */}
            {/* {user && (
                <div className="flex flex-col gap-1">
                    <p className="text-sm text-tertiary">Want to run your model on the edge?</p>
                    <a
                        href="https://calendly.com/d/cwng-fqd-5xz/chat-with-the-rapid-team"
                        target="_blank"
                        className="text-sm"
                        rel="noreferrer"
                    >
                        Talk with our team.
                    </a>
                </div>
            )} */}
            <SidebarActions>
                <MetricsSnippet />

                <div className="flex min-h-9 items-center" aria-hidden={!currentMedia?.file}>
                    {!!currentMedia?.file ? (
                        <motion.div
                            key="back-button"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: DEFAULT_DURATION.slower, ease: "easeOut" }}
                            className="w-full"
                        >
                            <Button type="secondary" onClick={handleBackClick} className="w-full">
                                <i className="far fa-undo"></i>
                                <span>Create New Model</span>
                            </Button>
                        </motion.div>
                    ) : (
                        <div className="h-9" />
                    )}
                </div>
            </SidebarActions>
        </>
    );
};
